export default __webpack_public_path__ + "static/screeny-150-storm-3-31a40591d74bdd30c5f222c5a7a32f98.jpg";